<script setup lang="ts">
// 빠른 녹음: 꾹 누르면(walkie-talkie식) 바로 녹음, 떼면 암호화 저장. 앱 어디서든 즉각.
// (홈 화면 위젯 길게 눌러 녹음은 네이티브 위젯 작업에서 이 플로우를 호출한다.)
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVaultStore } from '../stores/vault'
import { useUiStore } from '../stores/ui'
import { useRecorder, blobToB64, fmtSec } from '../composables/useRecorder'
import { icon } from '../lib/icons'

const { t } = useI18n()
const vault = useVaultStore()
const ui = useUiStore()
const emit = defineEmits<{ toast: [msg: string] }>()
const rec = useRecorder()
const held = ref(false)

async function down(e: PointerEvent) {
  e.preventDefault()
  ;(e.target as HTMLElement).setPointerCapture?.(e.pointerId)
  ui.holdAway() // 마이크 권한 창이 떠도 잠금 안 되게
  held.value = true
  const ok = await rec.start()
  if (!ok) { held.value = false; emit('toast', t('diary.noMic')) }
}
async function up() {
  if (!held.value) return
  held.value = false
  const r = await rec.stop()
  if (!r) return
  if (r.sec < 1) { emit('toast', t('diary.tooShort')); return }
  const b64 = await blobToB64(r.blob)
  const id = await vault.addAttachment('voice', r.blob.type, b64)
  await vault.addEntry('', [], t('diary.voiceInsight'), [{ id, kind: 'voice', sec: r.sec }])
  emit('toast', t('diary.voiceSaved', { d: fmtSec(r.sec) }))
}
</script>

<template>
  <button
    class="qrec" :class="{ on: rec.recording.value }"
    :title="t('diary.holdRec')" :aria-label="t('diary.holdRec')"
    @pointerdown="down" @pointerup="up" @pointerleave="up" @pointercancel="up" @contextmenu.prevent
  >
    <span v-if="rec.recording.value" class="qrec-sec">{{ fmtSec(rec.sec.value) }}</span>
    <span v-html="icon(rec.recording.value ? 'stop' : 'mic')"></span>
  </button>
</template>
